/**
 * Projets Slider
 */
import { Swiper } from 'swiper';
import { Navigation, EffectFade } from 'swiper/modules';

export function initProjetsSlider() {
    const projetsSlider = document.querySelector('.projets__slider');
    if (!projetsSlider) return;

    const prevButton = document.querySelector('.projets__nav-prev');
    const nextButton = document.querySelector('.projets__nav-next');

    const swiper = new Swiper(projetsSlider, {
        modules: [Navigation, EffectFade],
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        on: {
            init: function() {
                console.log('Projets slider initialized');
                updateContent(this.realIndex);
            },
            slideChange: function() {
                updateContent(this.realIndex);
            }
        }
    });

    // Function to update logo and tags based on active slide
    function updateContent(slideIndex) {
        const slides = document.querySelectorAll('.projets__slider .swiper-slide');
        const activeSlide = slides[slideIndex];
        
        if (!activeSlide) return;

        // Update logo
        const logo = activeSlide.getAttribute('data-logo');
        const logoImg = document.querySelector('.projets__client-logo img');
        if (logoImg && logo) {
            logoImg.src = document.querySelector('body').getAttribute('data-template-url') + logo;
        }

        // Update tags
        const tagsData = activeSlide.getAttribute('data-tags');
        const tagsContainer = document.querySelector('.projets__tags');
        
        if (tagsContainer && tagsData) {
            try {
                const tags = JSON.parse(tagsData);
                tagsContainer.innerHTML = '';
                
                tags.forEach(tag => {
                    const tagElement = document.createElement('span');
                    tagElement.className = 'tag tag--orange';
                    tagElement.textContent = tag;
                    tagsContainer.appendChild(tagElement);
                });
            } catch (e) {
                console.error('Error parsing tags data:', e);
            }
        }
    }

    // Add template URL to body for JS access
    if (!document.body.getAttribute('data-template-url')) {
        document.body.setAttribute('data-template-url', window.location.origin + '/wp-content/themes/nouslagence');
    }
}